import { ColumnDef } from "@tanstack/react-table";
import { ShotProfile } from "./ApolloShotProfileTable";

function formatCell(value: unknown, digits = 0) {
  if (value == null || typeof value !== "number") return "--";
  return `${(value as number).toFixed(digits)}${digits ? "%" : ""}`;
}

export const shotProfileColumns: ColumnDef<ShotProfile>[] = [
  {
    header: "Region",
    accessorKey: "region",
    enableSorting: false,
    cell: (props) => props.getValue(),
  },
  {
    header: "FGM",
    accessorKey: "fgm",
    enableSorting: false,
    cell: (props) => formatCell(props.getValue()),
  },
  {
    header: "FGA",
    accessorKey: "fga",
    enableSorting: false,
    cell: (props) => formatCell(props.getValue()),
  },
  {
    header: "FG%",
    accessorKey: "fgPct",
    enableSorting: false,
    cell: (props) => formatCell(props.getValue(), 1),
  },
  {
    header: "EFG%",
    accessorKey: "efgPct",
    enableSorting: false,
    cell: (props) => formatCell(props.getValue(), 1),
  },
  {
    header: "Share",
    accessorKey: "share",
    enableSorting: false,
    cell: (props) => formatCell(props.getValue(), 1),
  },
];
